import { Component, OnInit} from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MetasEditComponent } from '../metas-edit/metas-edit.component';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment} from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    //dateInput: 'L',
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-metas',
  templateUrl: './metas.component.html',
  styleUrls: ['./metas.component.css'],
  providers: [
    { provide: MatDialogRef,useValue: {} },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class MetasComponent implements OnInit {
  errMsg:any;
  loading:boolean=false;
  fecIni:any = _moment().startOf("month");
  metas:any=[];
  editando:boolean=false;


  constructor(private dataService: DataService, public dialogRef: MatDialogRef<MetasEditComponent>, public dialog: MatDialog) { }

  ngOnInit() {
    this.fnIniciar();
  } 

  fnIniciar(){
    this.loading = true;
    this.dataService.getMeta(0, this.fecIni.format("YYYYMM"), false).subscribe(
                      rows => {   
                              this.metas = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMetasCargadas());
  }

  fnMetasCargadas(){
    console.log(this.metas);
    this.loading = false
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    //console.log(this.fecIni);
    //console.log(normalizedMonth.format("YYYY/MM/DD"));
    this.fecIni = normalizedMonth;
    datepicker.close();
    this.fnIniciar();
  }

  fnEditar(item:any){
    //console.log(item);
    this.editando=true;
    let dialogRef = this.dialog.open(MetasEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id:item.idGpo,
                                            fecha:this.fecIni,
                                            mes:this.fecIni.locale("es-es").format("MMMM YYYY"),
                                            item:item
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    this.fnIniciar();
                                    }); 
  }

  fnNuevo(){
    this.editando=true;
    let dialogRef = this.dialog.open(MetasEditComponent, {
                                      width: "600px",
                                      data: { 
                                            id: -1,
                                            fecha:this.fecIni,
                                            mes:this.fecIni.locale("es-es").format("MMMM YYYY"),
                                            item:{'idGpo':-1, 'grupo':'NUEVO'}
                                            }
                                    });
    dialogRef.afterClosed().subscribe(result => {
                                    console.log("Popup cerrado");
                                    this.fnIniciar();
                                    }); 
  }

}
